import React from 'react';
import { useForm } from 'react-final-form';
import { Body } from '@lendi-ui/typography';

import { FIELD_VALUES, YES_NO_OPTIONS } from '@funnels/constants';
import { YesNoIntend } from '@funnels/types';
import { FunnelGrid, FunnelGridUnit, RadioButtonsField, TextAreaField } from '@funnels/ui-components';
import { HelpTooltip } from '@funnels/ui-components/_common';

import { MarginTopWrappered, RadioButtonsFieldWrappered } from './index.style';

interface CompanyRadioPanelProps {
  heading: string;
  name: string;
  tooltipText?: string;
  textAreaName?: string;
}

const YES_NO_INTEND_OPTIONS = [
  { label: 'Yes', value: YesNoIntend.YES },
  { label: 'No', value: YesNoIntend.NO },
  { label: 'Not for now, but the company plans to', value: YesNoIntend.INTEND },
];

export const CompanyRadioPanel = (props: CompanyRadioPanelProps) => {
  const { name, heading, tooltipText, textAreaName } = props;
  const { change, getFieldState } = useForm();
  const selectedValue = getFieldState(name)?.value;
  const onSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value === FIELD_VALUES.FALSE) {
      textAreaName && change(textAreaName, undefined);
    }
  };

  return (
    <FunnelGrid mt="md" mb="md" data-component={`${name}-container`}>
      <FunnelGridUnit size={1 / 2}>
        <Body>
          {heading}
          {tooltipText && <HelpTooltip content={tooltipText} position="right" />}
        </Body>
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <RadioButtonsFieldWrappered>
          <RadioButtonsField
            name={name}
            size="sm"
            radios={YES_NO_OPTIONS}
            noVerticalSpace
            selectedValue={selectedValue}
            isOptional
            isBoxed={false}
            onChange={onSelect}
          />
        </RadioButtonsFieldWrappered>
        {textAreaName && (
          <MarginTopWrappered>
            <TextAreaField
              label="Provide details"
              isOptional={!!selectedValue === false}
              isDisabled={!!selectedValue === false}
              disableFailMessage={!!selectedValue === false}
              rows={1}
              maxRows={2}
              name={textAreaName}
            />
          </MarginTopWrappered>
        )}
      </FunnelGridUnit>
    </FunnelGrid>
  );
};

export const CompanyIntendRadioPanel = (props: CompanyRadioPanelProps) => {
  const { name, heading, tooltipText, textAreaName } = props;
  const { change, getFieldState } = useForm();
  const selectedValue = getFieldState(name)?.value;
  const onSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value === YesNoIntend.NO) {
      textAreaName && change(textAreaName, undefined);
    }
  };

  return (
    <FunnelGrid mt="md" mb="md" data-component={`${name}-container`}>
      <FunnelGridUnit size={1 / 2}>
        <Body>{heading}</Body>
        {tooltipText && <HelpTooltip content={tooltipText} />}
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <RadioButtonsFieldWrappered>
          <RadioButtonsField
            name={name}
            size="sm"
            radios={YES_NO_INTEND_OPTIONS}
            noVerticalSpace
            selectedValue={selectedValue}
            isOptional
            isBoxed={false}
            onChange={onSelect}
          />
        </RadioButtonsFieldWrappered>
        {textAreaName && (
          <MarginTopWrappered>
            <TextAreaField
              label="Provide details"
              isOptional={selectedValue === YesNoIntend.NO || selectedValue === undefined}
              isDisabled={selectedValue === YesNoIntend.NO || selectedValue === undefined}
              disableFailMessage={selectedValue === YesNoIntend.NO || selectedValue === undefined}
              rows={1}
              maxRows={2}
              name={textAreaName}
            />
          </MarginTopWrappered>
        )}
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
